import { useEffect, useState } from "react";
import Logo from "@assets/images/logo.png";
import modules from "@/config/module";
import SidebarItem from "../extra/layouts/SidebarItem";
import { useLocation } from "react-router-dom";
import useAuth from "@/hooks/auth/useAuth";

export default function Sidebar() {
  let { pathname } = useLocation();
  const [routedPath, setRoutedPath] = useState(pathname);
  // Inside your component
  const { userData } = useAuth();
  //@ts-ignore
  const deptName = userData?.data?.dept_name;
  const isHR = deptName === "HR & Admin";

  // Only show "Employees" for non-HR users
  const visibleModules = isHR
    ? modules
    : modules.filter((mod) => mod.name === "Employees");
  useEffect(() => {
    setRoutedPath(pathname);
  }, [pathname]);

  return (
    <div className="w-64 bg-white border-r flex flex-col shadow-sm min-h-screen">
      {/* Logo */}
      <div className="flex items-center px-6 py-6 space-x-2">
        <img src={Logo} />
      </div>

      {/* Menu */}
      <nav className="flex-1 space-y-3 px-4">
        {visibleModules.map((module) => (
          <SidebarItem
            routedPath={routedPath}
            setRoutedPath={setRoutedPath}
            key={module.id}
            mainModule={module}
          />
        ))}
      </nav>
    </div>
  );
}
